import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "SupplierCompanyDashboardPage" */
	'pages/supplier/SupplierCompany/SupplierCompanyDashboardPage'));

export default [{ component, exact: true, path: '/supplier_companies/:supplierCompanyId' }];